export const countries = [
  { shortCode: 'AD', name: 'Andorra', code: '+376' },
  { shortCode: 'AE', name: 'United Arab Emirates', code: '+971' },
  { shortCode: 'AF', name: 'Afghanistan', code: '+93' },
  { shortCode: 'AG', name: 'Antigua And Barbuda', code: '+1268' },
  { shortCode: 'AI', name: 'Anguilla', code: '+1264' },
  { shortCode: 'AL', name: 'Albania', code: '+355' },
  { shortCode: 'AM', name: 'Armenia', code: '+374' },
  { shortCode: 'AN', name: 'Netherlands Antilles', code: '+599' },
  { shortCode: 'AO', name: 'Angola', code: '+244' },
  { shortCode: 'AQ', name: 'Antarctica', code: '+672' },
  { shortCode: 'AR', name: 'Argentina', code: '+54' },
  { shortCode: 'AS', name: 'American Samoa', code: '+1684' },
  { shortCode: 'AT', name: 'Austria', code: '+43' },
  { shortCode: 'AU', name: 'Australia', code: '+61' },
  { shortCode: 'AW', name: 'Aruba', code: '+297' },
  { shortCode: 'AZ', name: 'Azerbaijan', code: '+994' },
  { shortCode: 'BA', name: 'Bosnia And Herzegovina', code: '+387' },
  { shortCode: 'BB', name: 'Barbados', code: '+1246' },
  { shortCode: 'BD', name: 'Bangladesh', code: '+880' },
  { shortCode: 'BE', name: 'Belgium', code: '+32' },
  { shortCode: 'BF', name: 'Burkina Faso', code: '+226' },
  { shortCode: 'BG', name: 'Bulgaria', code: '+359' },
  { shortCode: 'BH', name: 'Bahrain', code: '+973' },
  { shortCode: 'BI', name: 'Burundi', code: '+257' },
  { shortCode: 'BJ', name: 'Benin', code: '+229' },
  { shortCode: 'BL', name: 'Saint Barthelemy', code: '+590' },
  { shortCode: 'BM', name: 'Bermuda', code: '+1441' },
  { shortCode: 'BN', name: 'Brunei Darussalam', code: '+673' },
  { shortCode: 'BO', name: 'Bolivia', code: '+591' },
  { shortCode: 'BR', name: 'Brazil', code: '+55' },
  { shortCode: 'BS', name: 'Bahamas', code: '+1242' },
  { shortCode: 'BT', name: 'Bhutan', code: '+975' },
  { shortCode: 'BW', name: 'Botswana', code: '+267' },
  { shortCode: 'BY', name: 'Belarus', code: '+375' },
  { shortCode: 'BZ', name: 'Belize', code: '+501' },
  { shortCode: 'CA', name: 'Canada', code: '+1' },
  { shortCode: 'CC', name: 'Cocos (keeling) Islands', code: '+61' },
  { shortCode: 'CD', name: 'Congo', code: '+243' },
  { shortCode: 'CF', name: 'Central African Republic', code: '+236' },
  { shortCode: 'CH', name: 'Switzerland', code: '+41' },
  { shortCode: 'CI', name: 'Cote D Ivoire', code: '+225' },
  { shortCode: 'CK', name: 'Cook Islands', code: '+682' },
  { shortCode: 'CL', name: 'Chile', code: '+56' },
  { shortCode: 'CM', name: 'Cameroon', code: '+237' },
  { shortCode: 'CN', name: 'China', code: '+86' },
  { shortCode: 'CO', name: 'Colombia', code: '+57' },
  { shortCode: 'CR', name: 'Costa Rica', code: '+506' },
  { shortCode: 'CU', name: 'Cuba', code: '+53' },
  { shortCode: 'CV', name: 'Cape Verde', code: '+238' },
  { shortCode: 'CX', name: 'Christmas Island', code: '+61' },
  { shortCode: 'CY', name: 'Cyprus', code: '+357' },
  { shortCode: 'CZ', name: 'Czech Republic', code: '+420' },
  { shortCode: 'DE', name: 'Germany', code: '+49' },
  { shortCode: 'DJ', name: 'Djibouti', code: '+253' },
  { shortCode: 'DK', name: 'Denmark', code: '+45' },
  { shortCode: 'DM', name: 'Dominica', code: '+1767' },
  { shortCode: 'DO', name: 'Dominican Republic', code: '+1809' },
  { shortCode: 'DZ', name: 'Algeria', code: '+213' },
  { shortCode: 'EC', name: 'Ecuador', code: '+593' },
  { shortCode: 'EE', name: 'Estonia', code: '+372' },
  { shortCode: 'EG', name: 'Egypt', code: '+20' },
  { shortCode: 'ER', name: 'Eritrea', code: '+291' },
  { shortCode: 'ES', name: 'Spain', code: '+34' },
  { shortCode: 'ET', name: 'Ethiopia', code: '+251' },
  { shortCode: 'FI', name: 'Finland', code: '+358' },
  { shortCode: 'FJ', name: 'Fiji', code: '+679' },
  {
    shortCode: 'FK',
    name: 'Falkland Islands (malvinas)',
    code: '+500',
  },
  {
    shortCode: 'FM',
    name: 'Micronesia, Federated States Of',
    code: '+691',
  },
  { shortCode: 'FO', name: 'Faroe Islands', code: '+298' },
  { shortCode: 'FR', name: 'France', code: '+33' },
  { shortCode: 'GA', name: 'Gabon', code: '+241' },
  { shortCode: 'GB', name: 'United Kingdom', code: '+44' },
  { shortCode: 'GD', name: 'Grenada', code: '+1473' },
  { shortCode: 'GE', name: 'Georgia', code: '+995' },
  { shortCode: 'GH', name: 'Ghana', code: '+233' },
  { shortCode: 'GI', name: 'Gibraltar', code: '+350' },
  { shortCode: 'GL', name: 'Greenland', code: '+299' },
  { shortCode: 'GM', name: 'Gambia', code: '+220' },
  { shortCode: 'GN', name: 'Guinea', code: '+224' },
  { shortCode: 'GQ', name: 'Equatorial Guinea', code: '+240' },
  { shortCode: 'GR', name: 'Greece', code: '+30' },
  { shortCode: 'GT', name: 'Guatemala', code: '+502' },
  { shortCode: 'GU', name: 'Guam', code: '+1671' },
  { shortCode: 'GW', name: 'Guinea-bissau', code: '+245' },
  { shortCode: 'GY', name: 'Guyana', code: '+592' },
  { shortCode: 'HK', name: 'Hong Kong', code: '+852' },
  { shortCode: 'HN', name: 'Honduras', code: '+504' },
  { shortCode: 'HR', name: 'Croatia', code: '+385' },
  { shortCode: 'HT', name: 'Haiti', code: '+509' },
  { shortCode: 'HU', name: 'Hungary', code: '+36' },
  { shortCode: 'ID', name: 'Indonesia', code: '+62' },
  { shortCode: 'IE', name: 'Ireland', code: '+353' },
  { shortCode: 'IL', name: 'Israel', code: '+972' },
  { shortCode: 'IM', name: 'Isle Of Man', code: '+44' },
  { shortCode: 'IN', name: 'India', code: '+91' },
  { shortCode: 'IQ', name: 'Iraq', code: '+964' },
  { shortCode: 'IR', name: 'Iran', code: '+98' },
  { shortCode: 'IS', name: 'Iceland', code: '+354' },
  { shortCode: 'IT', name: 'Italy', code: '+39' },
  { shortCode: 'JM', name: 'Jamaica', code: '+1876' },
  { shortCode: 'JO', name: 'Jordan', code: '+962' },
  { shortCode: 'JP', name: 'Japan', code: '+81' },
  { shortCode: 'KE', name: 'Kenya', code: '+254' },
  { shortCode: 'KG', name: 'Kyrgyzstan', code: '+996' },
  { shortCode: 'KH', name: 'Cambodia', code: '+855' },
  { shortCode: 'KI', name: 'Kiribati', code: '+686' },
  { shortCode: 'KM', name: 'Comoros', code: '+269' },
  { shortCode: 'KN', name: 'Saint Kitts And Nevis', code: '+1869' },
  { shortCode: 'KR', name: 'South Korea', code: '+82' },
  { shortCode: 'KW', name: 'Kuwait', code: '+965' },
  { shortCode: 'KY', name: 'Cayman Islands', code: '+1345' },
  { shortCode: 'KZ', name: 'Kazakstan', code: '+7' },
  { shortCode: 'LA', name: 'Laos', code: '+856' },
  { shortCode: 'LB', name: 'Lebanon', code: '+961' },
  { shortCode: 'LC', name: 'Saint Lucia', code: '+1758' },
  { shortCode: 'LI', name: 'Liechtenstein', code: '+423' },
  { shortCode: 'LK', name: 'Sri Lanka', code: '+94' },
  { shortCode: 'LR', name: 'Liberia', code: '+231' },
  { shortCode: 'LS', name: 'Lesotho', code: '+266' },
  { shortCode: 'LT', name: 'Lithuania', code: '+370' },
  { shortCode: 'LU', name: 'Luxembourg', code: '+352' },
  { shortCode: 'LV', name: 'Latvia', code: '+371' },
  { shortCode: 'LY', name: 'Libyan Arab Jamahiriya', code: '+218' },
  { shortCode: 'MA', name: 'Morocco', code: '+212' },
  { shortCode: 'MC', name: 'Monaco', code: '+377' },
  { shortCode: 'MD', name: 'Moldova', code: '+373' },
  { shortCode: 'ME', name: 'Montenegro', code: '+382' },
  { shortCode: 'MF', name: 'Saint Martin', code: '+1599' },
  { shortCode: 'MG', name: 'Madagascar', code: '+261' },
  { shortCode: 'MH', name: 'Marshall Islands', code: '+692' },
  { shortCode: 'MK', name: 'Macedonia', code: '+389' },
  { shortCode: 'ML', name: 'Mali', code: '+223' },
  { shortCode: 'MM', name: 'Myanmar', code: '+95' },
  { shortCode: 'MN', name: 'Mongolia', code: '+976' },
  { shortCode: 'MO', name: 'Macau', code: '+853' },
  { shortCode: 'MP', name: 'Northern Mariana Islands', code: '+1670' },
  { shortCode: 'MR', name: 'Mauritania', code: '+222' },
  { shortCode: 'MS', name: 'Montserrat', code: '+1664' },
  { shortCode: 'MT', name: 'Malta', code: '+356' },
  { shortCode: 'MU', name: 'Mauritius', code: '+230' },
  { shortCode: 'MV', name: 'Maldives', code: '+960' },
  { shortCode: 'MW', name: 'Malawi', code: '+265' },
  { shortCode: 'MX', name: 'Mexico', code: '+52' },
  { shortCode: 'MY', name: 'Malaysia', code: '+60' },
  { shortCode: 'MZ', name: 'Mozambique', code: '+258' },
  { shortCode: 'NA', name: 'Namibia', code: '+264' },
  { shortCode: 'NC', name: 'New Caledonia', code: '+687' },
  { shortCode: 'NE', name: 'Niger', code: '+227' },
  { shortCode: 'NG', name: 'Nigeria', code: '+234' },
  { shortCode: 'NI', name: 'Nicaragua', code: '+505' },
  { shortCode: 'NL', name: 'Netherlands', code: '+31' },
  { shortCode: 'NO', name: 'Norway', code: '+47' },
  { shortCode: 'NP', name: 'Nepal', code: '+977' },
  { shortCode: 'NR', name: 'Nauru', code: '+674' },
  { shortCode: 'NU', name: 'Niue', code: '+683' },
  { shortCode: 'NZ', name: 'New Zealand', code: '+64' },
  { shortCode: 'OM', name: 'Oman', code: '+968' },
  { shortCode: 'PA', name: 'Panama', code: '+507' },
  { shortCode: 'PE', name: 'Peru', code: '+51' },
  { shortCode: 'PF', name: 'French Polynesia', code: '+689' },
  { shortCode: 'PG', name: 'Papua New Guinea', code: '+675' },
  { shortCode: 'PH', name: 'Philippines', code: '+63' },
  { shortCode: 'PK', name: 'Pakistan', code: '+92' },
  { shortCode: 'PL', name: 'Poland', code: '+48' },
  { shortCode: 'PM', name: 'Saint Pierre And Miquelon', code: '+508' },
  { shortCode: 'PN', name: 'Pitcairn', code: '+870' },
  { shortCode: 'PR', name: 'Puerto Rico', code: '+1' },
  { shortCode: 'PT', name: 'Portugal', code: '+351' },
  { shortCode: 'PW', name: 'Palau', code: '+680' },
  { shortCode: 'PY', name: 'Paraguay', code: '+595' },
  { shortCode: 'QA', name: 'Qatar', code: '+974' },
  { shortCode: 'RO', name: 'Romania', code: '+40' },
  { shortCode: 'RS', name: 'Serbia', code: '+381' },
  { shortCode: 'RU', name: 'Russian Federation', code: '+7' },
  { shortCode: 'RW', name: 'Rwanda', code: '+250' },
  { shortCode: 'SA', name: 'Saudi Arabia', code: '+966' },
  { shortCode: 'SB', name: 'Solomon Islands', code: '+677' },
  { shortCode: 'SC', name: 'Seychelles', code: '+248' },
  { shortCode: 'SD', name: 'Sudan', code: '+249' },
  { shortCode: 'SE', name: 'Sweden', code: '+46' },
  { shortCode: 'SG', name: 'Singapore', code: '+65' },
  { shortCode: 'SH', name: 'Saint Helena', code: '+290' },
  { shortCode: 'SI', name: 'Slovenia', code: '+386' },
  { shortCode: 'SK', name: 'Slovakia', code: '+421' },
  { shortCode: 'SL', name: 'Sierra Leone', code: '+232' },
  { shortCode: 'SM', name: 'San Marino', code: '+378' },
  { shortCode: 'SN', name: 'Senegal', code: '+221' },
  { shortCode: 'SO', name: 'Somalia', code: '+252' },
  { shortCode: 'SR', name: 'Suriname', code: '+597' },
  { shortCode: 'ST', name: 'Sao Tome And Principe', code: '+239' },
  { shortCode: 'SV', name: 'El Salvador', code: '+503' },
  { shortCode: 'SY', name: 'Syria', code: '+963' },
  { shortCode: 'SZ', name: 'Swaziland', code: '+268' },
  { shortCode: 'TC', name: 'Turks And Caicos Islands', code: '+1649' },
  { shortCode: 'TD', name: 'Chad', code: '+235' },
  { shortCode: 'TG', name: 'Togo', code: '+228' },
  { shortCode: 'TH', name: 'Thailand', code: '+66' },
  { shortCode: 'TJ', name: 'Tajikistan', code: '+992' },
  { shortCode: 'TK', name: 'Tokelau', code: '+690' },
  { shortCode: 'TL', name: 'Timor-leste', code: '+670' },
  { shortCode: 'TM', name: 'Turkmenistan', code: '+993' },
  { shortCode: 'TN', name: 'Tunisia', code: '+216' },
  { shortCode: 'TO', name: 'Tonga', code: '+676' },
  { shortCode: 'TR', name: 'Turkey', code: '+90' },
  { shortCode: 'TT', name: 'Trinidad And Tobago', code: '+1868' },
  { shortCode: 'TV', name: 'Tuvalu', code: '+688' },
  { shortCode: 'TW', name: 'Taiwan, Province Of China', code: '+886' },
  { shortCode: 'TZ', name: 'Tanzania', code: '+255' },
  { shortCode: 'UA', name: 'Ukraine', code: '+380' },
  { shortCode: 'UG', name: 'Uganda', code: '+256' },
  { shortCode: 'US', name: 'United States', code: '+1' },
  { shortCode: 'UY', name: 'Uruguay', code: '+598' },
  { shortCode: 'UZ', name: 'Uzbekistan', code: '+998' },
  {
    shortCode: 'VA',
    name: 'Holy See (vatican City State)',
    code: '+39',
  },
  {
    shortCode: 'VC',
    name: 'Saint Vincent And The Grenadines',
    code: '+1784',
  },
  { shortCode: 'VE', name: 'Venezuela', code: '+58' },
  { shortCode: 'VG', name: 'Virgin Islands, British', code: '+1284' },
  { shortCode: 'VI', name: 'Virgin Islands, U.s.', code: '+1340' },
  { shortCode: 'VN', name: 'Vietnam', code: '+84' },
  { shortCode: 'VU', name: 'Vanuatu', code: '+678' },
  { shortCode: 'WF', name: 'Wallis And Futuna', code: '+681' },
  { shortCode: 'WS', name: 'Samoa', code: '+685' },
  { shortCode: 'XK', name: 'Kosovo', code: '+383' },
  { shortCode: 'YE', name: 'Yemen', code: '+967' },
  { shortCode: 'YT', name: 'Mayotte', code: '+262' },
  { shortCode: 'ZA', name: 'South Africa', code: '+27' },
  { shortCode: 'ZM', name: 'Zambia', code: '+260' },
  { shortCode: 'ZW', name: 'Zimbabwe', code: '+263' },
] as const;

export type ShortCode = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BR',
  'BS',
  'BT',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GQ',
  'GR',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PT',
  'PW',
  'PY',
  'QA',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'ST',
  'SV',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'XK',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
];
